import { cn } from "@newxsystems/shared";
import type { IBackgroundContainerBlockProps } from "./BackgroundContainerBlock.props";

const backgrounds: Record<string, string> = {
  canvas: "stratos-background-cloud",
  paper: "stratos-background-cloud",
  mint: "bg-mist text-night-flight",
  blue: "bg-horizon-blue text-night-flight",
  violet: "stratos-background-violet",
  dots: "bg-sunlit text-night-flight",
};

export const BackgroundContainerBlock = ({
  background,
  components,
  parentClass,
}: IBackgroundContainerBlockProps) => {
  if (!components) return null;

  return (
    <div
      className={cn(background ? backgrounds[background] : backgrounds.canvas, parentClass)}
      data-background={background || "canvas"}
      data-background-container=""
    >
      {components}
    </div>
  );
};

BackgroundContainerBlock.displayName = "Block::BackgroundContainerBlock";
